import { ConfiguratorAuthenticationService } from './configurator-authentication.service';

export const authServiceInit = (authService: ConfiguratorAuthenticationService) => {
    // init operazioni preliminari
    return () => authService.requestAccess();
};
